// filepath: /d:/Area de Trabalho/criandoparaweb/site/src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from './components/GoogleAds.vue';
import Maintenance from './components/Maintenance.vue';

const routes = [
 {
    path: '/',
    name: 'App',
    component: Home,
  },
  {
    path: '/google-ads',
    name: 'GoogleAds',
    component: Home,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/google-ads',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;